<template>
  <div>
    <ModalConfirmation
      :showModal="showModal"
      :title="title"
    >
      <template v-slot:body>
        <div>
          <InputLabel
            :class="$style.inputLabel"
            text="AWS Account Alias"
          />
          <TooltipIcon
            hasIndicator
            icon="info"
            :isMarkdown="false"
            isDark
            orientation="bottom"
            text="Please create a nickname for this account."
          />
          <InputText
            v-model="alias"
            :data-test-id="$testId('inputTextAlias')"
            name="AWS Account Alias"
            showValidationMessage
          />
        </div>
      </template>
      <template v-slot:footer>
        <ButtonGroup
          :isFullWidth="false"
        >
          <ButtonSecondary
            :data-test-id="$testId('cancelButton')"
            text="Cancel"
            @click="handleCancelClick"
          />
          <Button
            :data-test-id="$testId('saveButton')"
            text="Save"
            @click="handleSaveClick"
          />
        </ButtonGroup>
      </template>
    </ModalConfirmation>
  </div>
</template>

<script>
import {
  Button,
  ButtonGroup,
  ButtonSecondary,
  InputLabel,
  InputText,
  ModalConfirmation,
  TooltipIcon,
} from '@jumpcloud/ui-components';
import { mapActions } from 'vuex';

export default {
  name: 'EditAccountModal',

  components: {
    Button,
    ButtonGroup,
    ButtonSecondary,
    InputLabel,
    InputText,
    ModalConfirmation,
    TooltipIcon,
  },

  props: {
    account: {
      type: Object,
      required: true,
    },
    showModal: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      alias: '',
      loading: false,
    };
  },

  computed: {
    title() {
      return `Account ${this.account.awsAccountId}`;
    },
  },

  mounted() {
    this.alias = this.account.awsAccountAlias || '';
  },

  methods: {
    ...mapActions('CloudInsightsAccountsCollection', ['updateItem']),

    handleCancelClick() {
      this.reset();
      this.$emit('cancel');
    },

    async handleSaveClick() {
      this.loading = true;

      await this.updateItem({
        id: this.account.id,
        attributes: {
          ...this.account,
          awsAccountAlias: this.alias,
        },
      });

      this.loading = false;
      this.$emit('save');
    },

    reset() {
      this.alias = this.account.awsAccountAlias || '';
    },
  },
};
</script>

<style scoped module>

.inputLabel {
  font-size: var(--jcBody);
}
</style>
